import axios from 'axios';
import { useTranslation } from '@hfc/ui-core';

const SfCmsApiAxios = axios.create({});

SfCmsApiAxios.interceptors.request.use((config) => {
  config.headers['Accept-Language'] = useTranslation().locale.value;

  return config;
});

export { SfCmsApiAxios };
